export default __webpack_public_path__ + "static/media/olhofechado.e8b2ee01.svg";